import { Action as ActionType } from "@iva/store-utils";
import { ErrorPayload, IoState } from "#store/types";
import {
    Interpretation,
    OperatorInvocation,
} from "#services/pilotService/types";

/*******************************************************************************
 * types and interfaces
 ******************************************************************************/
export type OperatorInvocationMap = {
    [key: number]: IoState<OperatorInvocation>;
};

interface Operator {
    query: string;
}

class NlOperation implements Operator {
    query = "";
    database?: "siris" | "sdss";
    maxInterpretations?: number;
    maxResultsPerInterpretation?: number;
    nlToSqlInterpreter?: ("valuenet" | "nalir+" | "soda")[];
}

// Action types definition
export enum OperatorInvocationIdentifiers {
    FETCH_FROM_FROM_SERVER_SUCCEEDED = "@@operatorInvocations/FETCH_SUCCESS", // result from a successful read!
    FETCH_FROM_SERVER_STARTED = "@@operatorInvocations/FETCH_STARTED",
    FETCH_FROM_SERVER_FAILED = "@@operatorInvocations/FETCH_FAILED",
}

// Actions definition
export type OperatorInvocationSucceededActionType = ActionType<
    OperatorInvocationIdentifiers.FETCH_FROM_FROM_SERVER_SUCCEEDED,
    OperatorInvocation
>;
export type OperatorInvocationFailedActionType = ActionType<
    OperatorInvocationIdentifiers.FETCH_FROM_SERVER_FAILED,
    ErrorPayload
>;
export type OperatorInvocationStartedActionType = ActionType<
    OperatorInvocationIdentifiers.FETCH_FROM_SERVER_STARTED,
    number
>;
export type OperatorInvocationActionTypes =
    | OperatorInvocationSucceededActionType
    | OperatorInvocationFailedActionType
    | OperatorInvocationStartedActionType;

/*******************************************************************************
 * Reducer related stuff
 ******************************************************************************/

// State definition
export interface OperatorInvocationState {
    readonly operatorInvocations: {
        [key: number]: IoState<OperatorInvocation>;
    };
    // readonly query: string;
    // readonly pending: boolean[];
    // readonly requestId: string;
    // readonly tableResults: IQueryTableResult[];
}
